import React from "react";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useTranslationCandidates from "../useTranslationCandidates.js";
import useQueryApplicationByJobIdAndRecruiterIdRemainingCount from "./useQueryApplicationByJobIdAndRecruiterIdRemainingCount.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import Loader from "../../common/loading-widgets/Loader.js";
import InformationDisplay from "../../common/widgets/InformationDisplay.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";

export default function RemainingApplicationsSection(props) {
  const { jobId, recruiterId } = props;
  const {
    data: remainingApplicationsCount,
    loading,
    errors,
  } = useQueryApplicationByJobIdAndRecruiterIdRemainingCount(
    jobId,
    recruiterId
  );
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading, "RemainingApplicationsSection");

  return (
    <Loader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <InformationDisplay
            information={t(
              "candidates:candidates_job_remaining_recommendations_msg",
              {
                count: remainingApplicationsCount,
              }
            )}
            hoverInformation = {t(
              "candidates:candidates_job_remaining_recommendations_msg_hover")}
          />
        )}
      />
    </Loader>
  );
}
